import { render } from "./MessageInput.vue?vue&type=template&id=c145a0d0&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"

import "./MessageInput.vue?vue&type=style&index=0&id=c145a0d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c145a0d0"]])

export default __exports__